import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneIntel from './InputTel';

type InputTelControlledProps = {
  name: string;
  label?: string;
  error?: string;
};
const InputTelControlled = ({ name, label, error, ...props }: InputTelControlledProps) => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <PhoneIntel
          required
          label={label}
          error={errors[name]?.message as any}
          {...field}
          setValue={setValue as (name: string, value: unknown, config?: Object) => void}
        />
      )}
    />
  );
};

export default InputTelControlled;
